import { SkeletonRows } from "./Skeleton";
import { useEffect, useState } from "react";
import { getGiftFunding } from "../lib/api";
import type { GiftFundingPage } from "../types";

export function GiftFundingPanel() {
  const [page, setPage] = useState<GiftFundingPage | null>(null);
  const [skip, setSkip] = useState(0);
  const [version, refresh] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    setLoading(true); setError(null);
    getGiftFunding(skip).then((value) => { if (live) setPage(value); })
      .catch(() => { if (live) setError("Funding progress is unavailable. Check that the funding API is deployed."); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [skip, version]);
  const money = (cents: number) => (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });
  return <section className="history-card" aria-label="Gift funding progress">
    <div className="section-heading-row"><h2>Funding progress</h2>
      <button type="button" disabled={loading} onClick={() => refresh(version + 1)}>Refresh funding</button></div>
    <p className="transaction-story-note">Includes sends awaiting bank funding, before they appear in the escrow ledger. Bank-funded gifts wait until funds are available; the selected source covers the gift and fee.</p>
    {error ? <p role="alert">{error}</p> : null}
    <div className="table-wrap"><table><thead><tr><th>Gift</th><th>Total including fee</th><th>Source</th><th>Funding</th><th>Send operation</th></tr></thead>
      <tbody aria-busy={loading}>
        {!page && loading ? <SkeletonRows rows={3} columns={5} /> : null}
        {page?.items.map((item) => <tr key={item.giftId}>
          <td><strong>{item.giftId}</strong><small className="cell-subtitle">{item.operationId}</small></td>
          <td>{money(item.amountCents + item.feeCents)}<small className="cell-subtitle">{money(item.feeCents)} fee</small></td>
          <td>{item.source === "cash" ? "Ottagive Cash" : item.instant ? "Bank · instant" : "Bank · standard"}</td>
          <td>{item.phase.replaceAll("_", " ")}<small className="cell-subtitle">{item.giftState}</small></td>
          <td>{item.operationState}<small className="cell-subtitle">{item.errorCode}</small></td>
        </tr>)}
        {page?.items.length === 0 ? <tr><td colSpan={5}>No funding plans recorded.</td></tr> : null}
      </tbody></table></div>
    {page ? <div className="section-heading-row"><button disabled={loading || skip === 0} onClick={() => { setPage(null); setSkip(Math.max(0, skip - 25)); }}>Previous</button>
      <span>{page.totalCount} funding plans</span>
      <button disabled={loading || skip + page.items.length >= page.totalCount} onClick={() => { setPage(null); setSkip(skip + 25); }}>Next</button></div> : null}
  </section>;
}
